import React, { useEffect, useState } from 'react';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/custom/landingPages/Hero.js";
import Block1 from "components/custom/landingPages/Block1.js";
import Block2 from "components/custom/landingPages/Block2.js";
import Cta from "components/custom/landingPages/Cta.js";
import Quote from "components/custom/landingPages/Quote.js";
import Pricing from "components/custom/landingPages/Pricing.js";
import Resources from "components/custom/landingPages/Resources.js";
import Testimonials from "components/custom/landingPages/Testimonials.js";
import Footer from "components/custom/Footer.js";
import { useLocation } from 'react-router-dom';

import { Helmet } from 'react-helmet';

export default () => {
  const [urlPath, setUrlPath] = useState("");
  const [Content, setContent] = useState({
    "meta": {
        "title": "",
        "description": ""
    },
    "hero": {
        "notification": "",
        "h1": "",
        "paragraph1": "",
        "paragraph2": "",
        "linkTarget": "",
        "linkTitle": "",
        "linkText": "",
        "chartSymbol": "BTC/USD",
        "chartFeatures": [
            { id: 1, title: '', description: '' },
            { id: 2, title: '', description: '' },
        ],
        "reviewHeading": ""
    },
    "block1": {
        "heading": "",
        "paragraph": "",
        "imgAlt": "",
        "featureTitle1": "",
        "featureDescription1": "",
        "featureTitle2": "",
        "featureDescription2": "",
        "featureTitle3": "",
        "featureDescription3": "",
        "featureTitle4": "",
        "featureDescription4": ""
    },
    "quote": {
        "paragraph": ""
    },
    "resources": {
        "heading": "",
        "subheading": "",
        "description": "",
        "resources": [
            {
                "title": "",
                "description": "",
                "link": "",
                "linkText": ""
            },
            {
                "title": "",
                "description": "",
                "link": "",
                "linkText": ""
            },
            {
                "title": "",
                "description": "",
                "link": "",
                "linkText": ""
            },
            {
                "title": "",
                "description": "",
                "link": "",
                "linkText": ""
            }
        ]
    },
    "block2": {
        "heading": "",
        "paragraph": "",
        "imgAlt": ""
    },
    "pricing": {
        "heading": "",
        "subheading": "",
        "description": "",
        "primaryButtonText": "",
        "yearlyAdmonition": "",
        "lifetimeAdmonition": "",
        "tabs": {
            "Monthly": [],
            "Annual": [],
            "Lifetime": []
        },
        "plansDescription": "",
        "plansDescriptionAnnual": "",
        "plansDescriptionLifetime": "",
        "showYearlyPlans": "",
        "showLifetimePlans": "",
        "showMonthlyPlans": "",
        "joinGunbotCommunity": "",
        "moreDetailsAbout": "",
        "planFeatures": [
            "",
            ""
        ]
    },
    "cta": {
        "text": "",
        "linkText": "",
        "link": "",
        "linkTitle": ""
    }
}
);
  let location = useLocation();

  useEffect(() => {
    setUrlPath(location.pathname);
    const fileRef = location.pathname.replaceAll('/', '').replaceAll('topics', '');

    if (location.pathname !== "") {
      import(`../_content/pages/${fileRef}.js`)
        .then((module) => {
          setContent(module.default);
        })
        .catch((err) => {
          console.error("Content not found", err);
          setContent(null); // Handle not found content
        });
    }
  }, [location]);

  return (
    <>
      {Content ? (
        <>
          <Helmet>
            <title>{Content.meta.title}</title>
            <meta name="description" content={Content.meta.description} />
            <meta property="title" content={Content.title} />
            <link rel="canonical" href={`https://www.gunbot.com${urlPath}`} />
            {/* Other meta tags */}
            <script type="application/ld+json">
              {JSON.stringify(Content.ldJson4)}
            </script>
          </Helmet>
        </>
      ) : (
        <>
          <Helmet>
            <title>Loading...</title>
            <meta name="description" content="Loading..." />
          </Helmet>
        </>
      )}

      <AnimationRevealPage>
        <Hero content={Content.hero} />
        <Block1 content={Content.block1} />
        <Quote content={Content.quote} />
        <Block2 content={Content.block2} />
        <Testimonials />
        <Resources content={Content.resources} />
        <Pricing content={Content.pricing}/>
        <Cta content={Content.cta} />
        <Footer />
      </AnimationRevealPage>
    </>
  );
}
